import React from 'react';
import Header from '../components/Header';
import About from '../components/About';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import BrandMark from '../components/BrandMark';

const AboutPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <PageHeader
          title={(
            <span className="page-title-brand">
              <span>Sobre a</span>
              <BrandMark className="brand-mark-title" />
            </span>
          )}
          subtitle="Tecnologia, experiência e parceria para impulsionar os resultados dos nossos clientes."
          breadcrumb="Sobre"
          showPeriod={false}
        />
        <About />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
